import I18n from 'I18n';
export function getMonthsPerPeriod(periodISOString) {
  if (!periodISOString) {
    return null;
  }

  const duration = I18n.moment.duration(periodISOString.toUpperCase());
  return duration.asMonths();
}